






















































import {Prop, Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import {Widget, WidgetParameters} from "@/components/dashboard/Dashboard.vue";
import Http from "front-component/Http";
import _ from "lodash";
import Container from "@/components/dashboard/widgets/Container.vue";

interface Style {
    [property: string]: string | number;
}
interface M3QuickLoginParameters extends WidgetParameters {
    imageUrl?: string;
    cta?: {
        label: string;
        project: string;
        disabled: boolean;
        openInNewTab: boolean;
        route: string;
        url: string;
        reportUuid: string;
    };
}
interface M3QuickLoginData extends Widget {
    parameters: M3QuickLoginParameters;
}

interface M3Links {
    [key: string]: string;
}

const components = {
    Container,
};

@Component({components})

export default class M3QuickLogin extends Vue {
    public loading: boolean = false;
    public noLink: boolean = false;
    public wrongConfig: boolean = false;
    public links: M3Links = {};
    @Prop({default: null}) public widget !: M3QuickLoginData;

    protected created() {
        this.generateQuickLogin();
    }

    protected generateQuickLogin(): void {
        if (!this.widget.parameters.cta?.project) {
            this.wrongConfig = true;
            return;
        }
        this.loading = true;
        Http.get(
            `/m3/quick-link/${this.widget.parameters.cta.project}`,
            {},
            (data: { quickLogin: M3Links; }) => {
                this.links = data.quickLogin;
                this.loading = false;
            },
            () => {
                this.noLink = true;
                this.loading = false;
            }
        );
    }

    protected goTo(link: string): void {
        window.open(link, "_blank");
    }

    protected get hasSeveralLinks(): boolean {
        return Object.keys(this.links).length > 1;
    }

    protected get containerStyle(): Style {
        return {
            padding: 0,
        };
    }

    protected get titleStyle(): Style {
        return _.get(this.widget.parameters, "style.title", {});
    }

    protected get textStyle(): Style {
        return _.get(this.widget.parameters, "style.message", {});
    }
}
